import React from 'react'
import Helmet from 'react-helmet'
import { navigate } from 'gatsby'
import Header from '../components/Header'
import Cross from '../components/Cross'
import './../styles/styles.scss'
import { useSiteMetadata } from "../hooks/use-site-metadata"

export default ({ children }) => {

  const { year} = useSiteMetadata()
  const closeModal = e => {
    e.preventDefault()
    document.body.classList.remove('full_page_open')

    if (
      (typeof window !== 'undefined' && window.prevLocation !== null) ||
      document.referrer
    ) {
      window.history.back()
    } else {
      navigate('/')
    }
  }

  return (
    <>
      <Helmet>
        <title>Rapport annuel RSLR {year}</title>
        <meta
          name="description"
          content="Rapport annuel {year} du Réseau Santé Région Lausanne (RSRL)."
        />
      </Helmet>
      <section className="full-page">
        <div className="scroll-container">
          <Header >
            <Cross onClick={e => closeModal(e)} />
          </Header>
          <div className="full-page-content">{children}</div>
        </div>
      </section>
    </>
  )
}
